module.exports = __webpack_public_path__ + "media/customizations/myrtlecreek/back-cc687acca00d3d5d623bb79dcf9347d7.jpg";